import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { LandingButton } from '../../components/landing/LandingButton';

export function NotFoundPage() {
  useDocumentTitle('Page Not Found — KeepMyMail');
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4">
      <div className="max-w-md text-center">
        <div className="inline-flex items-center gap-2 rounded-full bg-secondary-container px-3 py-1 text-xs font-semibold text-primary mb-6">
          Error 404
        </div>
        <h1 className="font-headline text-5xl font-extrabold tracking-tighter text-on-surface mb-4">
          Page not found
        </h1>
        <p className="text-on-surface-variant text-lg leading-relaxed mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <LandingButton to="/">Go to Homepage</LandingButton>
      </div>
    </div>
  );
}
